import { on } from 'delegated-events';
import Pristine from 'pristinejs';
import scrollTo from '../common/scrollTo';

const SELECTORS = Selectors({
    styledForm: 'form--styled',
    ajaxForm: 'form--ajax',
    formAnchor: '[data-form-anchor]',
    formScroll: '[data-form-scroll]',
    formErrorMessage: 'form-error-message',
    field: 'field',
    focused: 'is-focused',
    loading: 'is-loading',
});

const $forms = document.querySelectorAll('form');

export const pristineConfig = {
    classTo: 'field',
    errorClass: 'has-error',
    successClass: 'has-success',
    errorTextParent: 'field',
    errorTextTag: 'div',
    errorTextClass: 'text-help',
};

Pristine.addValidator(
    'currency-integer',
    function(value) {
        if (value === '') {
            return true;
        }

        value = value.replace('$', '');

        return !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10)) && value > 0;
    },
    'Please enter a whole dollar amount',
    1,
    false
);

const fn = {
    init: () => {
        // Only setup any custom forms defined by our classes
        const customForms = [ SELECTORS.styledForm, SELECTORS.ajaxForm ];
        const $customForms = Array.from($forms).filter($f => {
            // Handle cases where we wrap the form with an element (ex: SilverStripe forms)
            if ($f.closest(SELECTORS.asClass('styledForm'))) {
                return true;
            }

            return customForms.some(x => $f.classList.contains(x));
        });

        if ($customForms.length) {
            $customForms.forEach($f => fn.setupForm($f));
        }

        on('change', '.has-field-error', e => {
            const $field = e.target.closest('.field');

            e.target.classList.remove('has-field-error');

            if ($field.classList.contains('checkbox')) {
                $($field).closest('ul').find('.has-field-error').removeClass('has-field-error');
            }
        });
    },

    setupForm: $form => {
        if (!$form.classList.contains('has-custom-validation')) {
            fn.setupValidation($form);
        }

        // Setup file inputs
        $form.querySelectorAll('input[type=file]').forEach($el => {
            const $input = $el;
            const $placeholder = document.createElement('div');
            $placeholder.classList.add('file-input-placeholder');

            if ($input.value) {
                $placeholder.textContent = $input.files[0].name;
            } else {
                $placeholder.textContent = $input.getAttribute('placeholder');
            }

            $input.parentNode.insertBefore($placeholder, $input);

            $placeholder.addEventListener('click', () => $input.click());
            $input.addEventListener('change', e => {
                $placeholder.textContent = e.target.files[0].name;
                $placeholder.classList.add('filled');
                $input.closest('.field').classList.add('is-focused');
            });
        });

        // Setup form's submit button(s) to handle cases where we want to skip validation
        $form.querySelectorAll('[type=submit]').forEach($el => {
            $el.addEventListener('click', function() {
                this.form.skipValidation = this.getAttribute('formnovalidate') === 'formnovalidate';
            });
        });
    },

    setupValidation: $form => {
        const allowScroll = $form.matches(SELECTORS.formScroll);
        const pristine = new Pristine($form, pristineConfig);

        // reset all validation on nomination form type change
        /*
        on('change', `${SELECTORS.asClass('styledForm')} select[name="NominationType"]`, function() {
            window.setTimeout(function() {
                pristine.destroy();
                fn.setupForm($form);
            }, 100);
        });
        */

        // Revalidate easydropdown fields on change
        on('change', `${SELECTORS.asClass('styledForm')} select`, e => pristine.validate(e.target));

        // Hide any native SilverStripe errors
        on('keyup', `${SELECTORS.asClass('styledForm')} input`, e => {
            const $field = e.target.closest('.field');
            const $error = $field.querySelector('.message');

            if ($error) {
                $error.remove();
            }
        });

        $form.addEventListener('submit', e => {
            if (e.target.skipValidation) {
                return true;
            }

            const valid = pristine.validate();

            if (!valid) {
                e.preventDefault();
                const $firstError = $form.querySelector('.field.has-error');

                if ($firstError && allowScroll) {
                    scrollTo($firstError, 150, () => $firstError.querySelector('input').focus());
                }

                return false;
            }

            // Handle ajax submit if appropriate
            if ($form.classList.contains(SELECTORS.ajaxForm)) {
                e.preventDefault();

                const $errorMessage = $form.querySelector(SELECTORS.asClass('formErrorMessage'));
                $errorMessage.style.display = 'none';

                const $submitButton = $form.querySelector('[type=submit]');
                $submitButton.disabled = true;
                $submitButton.classList.add(SELECTORS.loading);

                const formData = new FormData($form);

                $.ajax({
                    type: 'post',
                    url: $form.action,
                    data: formData,
                    dataType: 'json',
                    processData: false,
                    contentType: false,
                    success: resp => {
                        if (resp.success) {
                            $form.innerHTML = `<div class="form-success-message">${resp.message}</div>`;

                            // Figure out where to scroll to
                            let $anchor = $form.closest(SELECTORS.formAnchor);
                            $anchor =
                                $anchor ? $anchor :
                                $form;

                            if (allowScroll) {
                                scrollTo($anchor, 150);
                            }
                        } else {
                            $errorMessage.innerHTML = resp.message;
                            $errorMessage.style.display = 'block';

                            if (resp.field_errors) {
                                for (const field of resp.field_errors) {
                                    const $field = $form.querySelector(`[name="${field}"]`);

                                    if ($field) {
                                        $field.classList.add('has-field-error');
                                    }
                                }
                            }
                        }
                    },
                    error: () => {
                        $errorMessage.innerHTML = 'Sorry, there was a problem with your submission';
                        $errorMessage.style.display = 'block';
                    },
                    complete: () => {
                        $submitButton.disabled = false;
                        $submitButton.classList.remove(SELECTORS.loading);
                    },
                });
            }

            return valid;
        });
    },
};

export const Form = {
    init: $form => {
        fn.setupForm($form);
    },
};

export default {
    can: () => $forms.length,
    run: fn.init,
};
